// src/auth/userManager.js
import { UserManager, WebStorageStateStore } from "oidc-client-ts";

/**
 * Configuration for the oidc-client-ts library.
 * Reads environment variables (prefixed with REACT_APP) for better security.
 */

const config = {
    authority: "https://copadata.onelogin.com/oidc/2", // OneLogin Issuer URL
    client_id: "7f463650-e61f-013d-3c68-01e279be564738555",
    redirect_uri: window.location.origin + "/callback",
    response_type: "code",
    scope: "openid profile email params",
    post_logout_redirect_uri: "https://sla-checker.copatools.com",
    userStore: new WebStorageStateStore({ store: window.localStorage }),
    loadUserInfo: true
};

/**
 * A shared UserManager instance used throughout the application.
 */
const userManager = new UserManager(config);

export default userManager;




